<mat-card>
    <mat-card-content>
        <div fxLayout="column">
            <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
                <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
                    <div>
                        <strong class="noMarginHeader">Results ({{ tableDataFiltered.length }})</strong>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <mat-form-field style="width:200px;">
                            <input (keyup)="filterTable()" placeholder="Filter Results" [(ngModel)]="filterTableString" matInput />
                        </mat-form-field>
                    </div>
                    <div fxLayoutGap="8px" fxLayoutAlign="center center">
                        <mat-form-field style="width: 180px;">
                            <mat-label>Document Type</mat-label>
                            <mat-select [(ngModel)]="selectedDocumentType">
                                <mat-option *ngFor="let type of documentTypes" [value]="type">{{ type }}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <input type="file" id="courseDocumentFileInput" (change)="onFileSelected($event)" style="display: none;">
                        <button mat-raised-button color="primary" [disabled]="uploading || courseId === 0" (click)="triggerFileInput()">
                            <mat-icon>upload_file</mat-icon>
                            {{ uploading ? 'Uploading...' : 'Upload Document' }}
                        </button>
                    </div>
                </div>
                <div style="text-align: right; color: #666; font-size: 12px; margin-top: 4px;">
                    Accepted file types: {{ acceptedFileTypes }}
                </div>

                <br />

                <!-- Loading Spinner -->
                <div *ngIf="loading" style="display: flex; justify-content: center; padding: 40px;">
                    <mat-spinner></mat-spinner>
                </div>

                <!-- No Documents Message -->
                <div *ngIf="!loading && tableDataFiltered.length === 0" style="text-align: center; padding: 40px; color: grey;">
                    <mat-icon style="font-size: 48px; width: 48px; height: 48px;">folder_open</mat-icon>
                    <p>No documents found for this course.</p>
                    <p>Upload a document to get started.</p>
                </div>

                <!-- Documents Table -->
                <mat-table *ngIf="!loading && tableDataFiltered.length > 0" [dataSource]="tableDataSource" matSort #TableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
                    <mat-header-row fxLayout="row" fxLayout.lt-md="column" *matHeaderRowDef="tableColumns"></mat-header-row>
                    <mat-row fxLayout="row" fxLayout.lt-md="column" *matRowDef="let row; columns: tableColumns" [ngStyle]="{'--hover-bg-color': sharedService.hoverBackgroundColor}"></mat-row>

                    <ng-container *ngFor="let cellData of tableFormat; let i = index" [matColumnDef]="cellData.columnName">
                        <mat-header-cell mat-sort-header [fxFlex]="cellData.size" *matHeaderCellDef>{{ cellData.displayName }}</mat-header-cell>
                        <mat-cell *matCellDef="let row" [fxFlex]="cellData.size" matTooltip="{{ row[cellData.columnName] }}">
                            <ng-container [ngSwitch]="cellData.type">
                                <ng-container *ngSwitchCase="'date'">
                                    {{ row[cellData.columnName] | date:'MM/dd/yyyy' }}
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    <span>{{ row[cellData.columnName] }}</span>
                                </ng-container>
                            </ng-container>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <mat-header-cell *matHeaderCellDef fxFlex="10">Actions</mat-header-cell>
                        <mat-cell *matCellDef="let row" fxFlex="10">
                            <button mat-icon-button color="primary" (click)="downloadFile(row); $event.stopPropagation()" matTooltip="Download">
                                <mat-icon>download</mat-icon>
                            </button>
                            <button mat-icon-button color="warn" (click)="deleteFile(row); $event.stopPropagation()" matTooltip="Delete">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </mat-cell>
                    </ng-container>
                </mat-table>

                <br />
                <mat-paginator [pageSize]="tablePageSize" [pageSizeOptions]="[5, 10, 50, tableData.length]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
            </div>
        </div>
    </mat-card-content>
</mat-card>
